<template>
  <div>
    <v-container
      fluid
      grid-list-md
    >
      <h1 class="text-h5 mb-6">{{ $t('Receipts') }}</h1>
      <receipts-table include-search />
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue'
import ReceiptsTable from '@/components/receipts/ReceiptsTable'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    ReceiptsTable
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Receipts')
  })
}
</script>



// WEBPACK FOOTER //
// src/views/receipts/Index.vue